<template>
  <div v-if="isShow" style="width: 100%;" @click="handleChangeTheme()">
    <a :class="{'nav_dropdown_item':level? false:true,'menu_expand_item': level? true:false, 'nav_dropdown_item__reverse': isReverse}" :style="{'background': level? '':background}" @click="dropdownAction()">
      <div v-if="menuIcon && menuIcon !== '' && !level" class="menu_icon">
        <svg-icon :name="menuIcon" />
      </div>
      <div :class="level? 'menu_expand_title':'menu_title'" @click="titleAction()">
        {{ menuTitle }}
      </div>
      <span v-if="canExpand" class="menu_expand_icon" :class="isExpand ? 'open' : ''" @click="arrowAction()">
        <svg-icon name="chevron-down" color="#FFFFFF" />
      </span>
      <template v-if="isChangeTheme">
        <span class="settings_switch_status" style="margin-left: 15px">Light</span>
        <switch-button
          v-model="themeStatus"
          @toggle="handleChangeTheme"
        />
        <span class="settings_switch_status">Dark</span>
      </template>
    </a>
    <div :class="{'nav_dropdown_menu_expand': true, 'sub_menu': level === 1, 'show': canExpand && isExpand && (getDataExpand.length > 0 || Object.keys(getDataExpand).length > 0)}">
      <template v-for="(item, index) in getDataExpand">
        <template v-if="item.canExpand">
          <nav-dropdown-item
            :key="index"
            :menu-title="item.menuTitle"
            :href="item.href"
            :action="item.action"
            :can-expand="item.canExpand"
            :expand-data="item.expandData"
            :is-show="item.isShow"
            :expand-function="item.expandFunction"
            :level="item.level"
          />
        </template>
        <template v-else>
          <a
            v-if="!level"
            :key="index"
            class="menu_expand_item"
            :href="item.href"
            @click.stop.prevent="redirectToExpandHref(item.href)"
          >
            {{ item.text }}
          </a>
          <a
            v-else-if="item.canShow"
            :key="index"
            class="menu_expand_item"
            :href="item.href"
            @click.stop.prevent="redirectToExpandHref(item.href)"
          >
            {{ item.text }}
          </a>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import SvgIcon from '../../shared/icons/index';
import SwitchButton from '../../profile/profile-menu/settings_tab/swtich-button';
import { EventBus, HANDLE_CHANGE_THEME, HANDLE_CHANGE_THEME_SETTING, TOGGLE_TOP_MENU_LOGO, STOP_FORCE_SHOW_MENU_HAMBURGER } from '../../../event-bus';

export default {
  name: 'NavDropdownItem',
  components: { SvgIcon, SwitchButton },
  mixins: [component],
  props: {
    background: {
      type: String,
      default: '#322F52',
    },
    menuIcon: {
      type: String,
      default: 'star',
    },
    menuTitle: {
      type: String,
      default: 'My Sessions',
    },
    action: {
      type: Function,
      default: function(){},
    },
    href: {
      type: String,
      default: 'javascript:void(0)',
    },
    canExpand: {
      type: Boolean,
      default: false,
    },
    expandData: {
      type: [Object, Function],
      default() {
        return {};
      },
    },
    expandFunction: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShow: {
      type: [Boolean, Number],
      default() {
        return true;
      },
    },
    isReverse: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isChangeTheme: {
      type: Boolean,
      default() {
        return false;
      },
    },
    titleColor: {
      type: String,
      default() {
        return '#FFFFFF';
      },
    },
    level: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      isExpand: false,
      themeStatus: 1,
      dataExpand: {},
    };
  },
  computed: {
    getDataExpand() {
      return this.dataExpand;
    },
  },
  created() {
    this.setSwitchTheme();
    EventBus.$on(HANDLE_CHANGE_THEME_SETTING, this.handleChangeTheme);
  },
  beforeDestroy() {
    EventBus.$off(HANDLE_CHANGE_THEME_SETTING);
  },
  methods: {
    dropdownAction() {
      if (this.level === 0) {
        if (this.href !== 'javascript:void(0)') {
          window.location = this.href;
        } else {
          this.action();
          this.toggleExpand();
        }
      }
    },
    titleAction() {
      if (this.level > 0) {
        if (this.href !== 'javascript:void(0)') {
          window.location = this.href;
        } else {
          this.action();
          this.toggleExpand();
        }
      }
    },
    arrowAction() {
      if (this.level > 0) {
        this.toggleExpand();
      }
    },
    async toggleExpand() {
      // show expand object in menu
      if (!this.isExpand) {
        if (this.expandFunction) {
          this.dataExpand = await this.expandData();
        } else {
          this.dataExpand = this.expandData;
        }
      }
      this.isExpand = !this.isExpand;
    },
    setSwitchTheme() {
      const theme = localStorage.getItem('theme');
      if (theme === 'light') {
        this.themeStatus = 1;
      } else {
        this.themeStatus = 0;
      }
    },
    async handleChangeTheme(status){
      if (!this.isChangeTheme) {
        return;
      }
      // check theme on mobile device
      if (this.isMobile()) {
        const isDeviceDarkTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        status = isDeviceDarkTheme ? 0 : 1;
        console.log('change status to: ' + status + ' due to device theme dark is ' + isDeviceDarkTheme);
      }
      if (typeof status !== 'undefined') {
        this.themeStatus = status;
      } else {
        this.themeStatus = this.themeStatus === 1 ? 0 : 1;
      }
      const dataUpdate = {};
      dataUpdate['field'] = 'theme';
      dataUpdate['status'] = this.themeStatus;
      EventBus.$emit(HANDLE_CHANGE_THEME, this.themeStatus);
      if (this.themeStatus === 0) { // dark theme
        localStorage.setItem('theme', 'dark');
        document.documentElement.setAttribute('data-theme', 'dark');
        const dataUpdate = {};
        dataUpdate['theme'] = 'dark';
        if (this.targetUserData && this.targetUserData.theme){
          this.targetUserData.theme = 'dark';
        }
        this.$store.dispatch('user/updateUser', dataUpdate);
        await this.updateBackgroundFollowByTheme('dark');
      } else { // light theme
        localStorage.setItem('theme', 'light');
        document.documentElement.setAttribute('data-theme', 'light');
        const dataUpdate = {};
        dataUpdate['theme'] = 'light';
        if (this.targetUserData && this.targetUserData.theme){
          this.targetUserData.theme = 'light';
        }
        this.$store.dispatch('user/updateUser', dataUpdate);
        await this.updateBackgroundFollowByTheme('light');
      }
      const oldTheme = this.themeStatus === 1 ? 0 : 1;
      const oldCssTitan = this.getCssTitan(oldTheme);
      this.updateDiscordEmbedTheme(this.themeStatus, oldCssTitan);
      this.updateTwitchEmbedTheme(this.themeStatus);
    },
    updateDiscordEmbedTheme(themeStatus, oldCssTitan) {
      const iframeDiscordHub = document.getElementById('chat_embed');
      const iframeDiscordEvent = document.getElementById('chat_embed_discord');
      const cssTitan = this.getCssTitan(themeStatus);
      if (iframeDiscordHub) {
        const strReplace = 'css=' + cssTitan;
        const target = 'css=' + oldCssTitan;
        let iframeDiscordHubSrc = iframeDiscordHub.getAttribute('src');
        iframeDiscordHubSrc = iframeDiscordHubSrc.replace(target, strReplace);
        iframeDiscordHub.setAttribute('src', iframeDiscordHubSrc);
      }
      if (iframeDiscordEvent) {
        const strReplace = 'css=' + cssTitan;
        const target = 'css=' + oldCssTitan;
        let iframeDiscordEventSrc = iframeDiscordEvent.getAttribute('src');
        iframeDiscordEventSrc = iframeDiscordEventSrc.replace(target, strReplace);
        iframeDiscordEvent.setAttribute('src', iframeDiscordEventSrc);
      }
    },
    getCssTitan(themeStatus) {
      let cssTitan = this.appConfig.css_titan;
      if (themeStatus === 0) { // dark theme
        if (this.appConfig.isAvglDomain) {
          cssTitan = this.appConfig.css_titan_avgl;
        }
      } else {
        cssTitan = this.appConfig.css_titan_light_theme;
      }
      return cssTitan;
    },
    updateTwitchEmbedTheme(themeStatus) {
      const iframeTwitchEmbed = document.getElementById('chat_embed_twitch');
      const replaceString = 'darkpopout&';
      if (iframeTwitchEmbed) {
        const iframeSrc = iframeTwitchEmbed.getAttribute('src');
        if (themeStatus === 0) { // dark theme
          const arraySrc = iframeSrc.split('/chat?');
          const newIframeSrc = arraySrc[0] + '/chat?' + replaceString + arraySrc[1];
          iframeTwitchEmbed.setAttribute('src', newIframeSrc);
        } else {
          const newIframeSrc = iframeSrc.replace(replaceString, '');
          iframeTwitchEmbed.setAttribute('src', newIframeSrc);
        }
      }
    },
    updateBackgroundFollowByTheme(theme){
      const prefixLightTheme = '_light_theme';
      if (!this.targetUserData || !this.targetUserData.background_img){
        return;
      }
      if (theme === 'dark'){
        if (this.targetUserData.background_img.includes(prefixLightTheme)){
          const arr = this.targetUserData.background_img.split(prefixLightTheme);
          this.targetUserData.background_img = arr.join('');
        }
      } else if (theme === 'light'){
        if (!this.targetUserData.background_img.includes(prefixLightTheme)){
          const arr = this.targetUserData.background_img.split('.png');
          this.targetUserData.background_img = arr.join(prefixLightTheme + '.png');
        }
      }
    },
    redirectToExpandHref(href) {
      const currentUrlNotHash = location.protocol + '//' + location.host + location.pathname;
      if (this.expandFunction && href.includes('#') && currentUrlNotHash === href.split('#')[0]) {
        // change hash when URL is the same
        window.location.hash = '#' + href.split('#')[1];
        location.reload();
        return;
      } else if (!this.expandFunction && href.includes('#') && currentUrlNotHash === href.split('#')[0]) {
        EventBus.$emit(TOGGLE_TOP_MENU_LOGO, true);
        EventBus.$emit(STOP_FORCE_SHOW_MENU_HAMBURGER);
      }
      window.location.href = href;
    },
  },
};
</script>
